module.exports = __webpack_public_path__ + "static/IWGHQI0-8f4266f5df7baf2c390f46520b69eb5e.png";